import { JobStageType } from '@shared/generated';

export const isJobStageType = (value: unknown): value is JobStageType => {
  return Object.values(JobStageType).includes(value as JobStageType);
};
